export default "__VITE_ASSET__CrpWKxyO__"